import voca from 'voca';
import { getPreBuiltSections } from '../pluginComponentApi';
export default async function (editor, opts = {}) {
  const c = opts;
  const bm = editor.BlockManager;
  const pfx = c.pfx;

  const { data: preBuiltSectionResponse } = await getPreBuiltSections(opts.projectId);
  let preBuiltSectionSelectList = [];
  if (preBuiltSectionResponse && preBuiltSectionResponse.length) {
    preBuiltSectionResponse.map((preBuiltSectionBlock) => {
      let preBuiltSecSelObj = {};
      preBuiltSecSelObj['id'] = preBuiltSectionBlock.name;
      preBuiltSecSelObj['block'] = preBuiltSectionBlock;
      preBuiltSectionSelectList.push(preBuiltSecSelObj);
    });
  }

  preBuiltSectionSelectList &&
    preBuiltSectionSelectList.map((preBuiltSection) => {
      const imageUrl = `${process.env.REACT_APP_S3_URL}${preBuiltSection.block.image}`;
      bm.add(`prebuilt__${preBuiltSection.block.type}`, {
        label: `
      <img src="${imageUrl}" loading="lazy" class="mkp-components" width="250" height="auto">
        <div class="gjs-block-label">${preBuiltSection.block.label}</div>`,
        category: `<span style="display: none;">Pre-Built</span>${voca.capitalize(
          preBuiltSection.block.category[0],
          true,
        )}`,
        // activate: true,
        select: true,
        //?INFO: Uncomment the content block below to wrap a component container around the prebuilt layout
        // content: `
        // <div class='${pfx} width100' style="width:100%" data-js=${c.refs.preBuiltSectionRef} data-gjs-type=${c.refs.preBuiltSectionRef}>

        // ${preBuiltSection.block.contentStyle}
        // ${preBuiltSection.block.contentHtml}

        // </div>`,
        content: `
      ${preBuiltSection.block.contentStyle}
      ${preBuiltSection.block.contentHtml}
      `,
        render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="https://academy.drapcode.com/docs/app-pre-built-section/introduction-to-pre-built-section" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
          preBuiltSection.block.label
        }?"></i>
        </a>
      </span>
    `,
      });
    });
}
